<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <p-toast key="toastmsg" position="top-right"></p-toast>
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <form [formGroup]="sponsorsForm" *ngIf="this.sponsorsForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pageTitle}}
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">

                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <!-- <div class="p-field p-col-10">
                            <label for="category">Category</label>
                            <p-dropdown inputId="category" [options]="categories" formControlName="category"
                                placeholder="Select" optionLabel="label" placeholder="Select Category" ></p-dropdown>
                            <div *ngIf="submitted && f.category.errors" class="invalid-feedback">
                                <div *ngIf="f.category.errors.required">Please Select Category</div>
                            </div>
                        </div> -->


                                <div class="p-field p-col-6 addFormDropDown">
                                    <label for="category">Select Category <span
                                            class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="category" [options]="categorylist" formControlName="category"
                                        placeholder="Select" optionLabel="name"
                                        [ngClass]="{ 'is-invalid': submitted && f.category.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.category.errors" class="invalid-feedback">
                                        <div *ngIf="f.category.errors.required">Please Select Category</div>
                                    </div>
                                </div>


                                <div class="p-field p-col-6">
                                    <label for="title">Title<span class="mandatory-feilds">*</span></label>
                                    <input id="title" formControlName="title" type="text" pInputText
                                        placeholder="Enter Title"
                                        [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                                    <div *ngIf="((submitted && f.title.errors) || (f.title.errors && (f.title.dirty || f.title.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.title.errors.required">Title is required</div>
                                    </div>
                                </div>

                                <div class="p-field p-col-6">
                                    <label for="brandName">Brand Name<span class="mandatory-feilds">*</span></label>
                                    <input id="brandName" formControlName="brandName" type="text" pInputText
                                        placeholder="Enter Brand name"
                                        [ngClass]="{ 'is-invalid': submitted && f.brandName.errors }">
                                    <div *ngIf="((submitted && f.brandName.errors) || (f.brandName.errors && (f.brandName.dirty || f.brandName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.brandName.errors.required">Brand Name is required</div>
                                    </div>
                                </div>

                                <div class="p-field p-col-6">
                                    <label for="link">Link </label>
                                    <input formControlName="link" id="link" type="text" pInputText
                                        placeholder="Enter Url Link" class="form-control">
                                </div>
                                <div class="lineborderHR">
                                    <hr>
                                </div>

                                <div class="p-field p-col-12 uploadBtn">
                                    <div class="subTitleLable">
                                        <h4>Image</h4>
                                    </div>

                                    <!-- <label for="article"><span class="mandatory-feilds">*</span></label> -->
                                    <!-- <p-fileUpload chooseLabel="Upload Image" uploadLabel="Sponsor Image"
                                        cancelLabel="Cancel" accept="image/*" maxFileSize="{{imageSize}}" auto="auto"
                                        customUpload="true" (uploadHandler)="picUploader($event)"
                                        (onRemove)="removeFile($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload> -->
                                    <p-fileUpload #fileUpload mode="advanced" name="myfile[]" chooseLabel="Upload Image"
                                        uploadLabel="Sponsor Image" cancelLabel="Cancel" accept="image/*"
                                        maxFileSize="2000000" auto="auto" customUpload="true"
                                        [ngClass]="{ 'is-invalid': submitted }"
                                        (onSelect)="onFileSelect($event)"></p-fileUpload>
                                    <div class="error-msg" *ngIf="notproduct">
                                        Please Upload Sponsor Image
                                    </div>
                                </div>
                                <div class="instruction p-field p-col-12">
                                    <p>Instructions: </p>
                                    <ul>
                                        <li>The Sponsor Image must be exactly 1583px width × 633px height (square
                                            format) for proper display. <b>E.g.:-</b> (<a
                                                href="/assets/samplefiles/brandsponsorlogo.png" target="_blank"
                                                rel="noopener noreferrer">Image</a>)</li>
                                        <li>Keep the white background of image with some padding around the image.</li>
                                        <li>Keep the file size optimized for fast loading and better performance, with a
                                            maximum size of 2 MB. </li>
                                    </ul>
                                </div>
                                <div class="lineborderHR">
                                    <hr>
                                </div>

                                <div class="p-field p-col-6 p-0">
                                    <div class="p-field p-col-4">
                                        <div class="addBigSwich ">
                                            <label for="status">Status</label>
                                            <div class="swichTable">
                                                <p-inputSwitch formControlName="status"></p-inputSwitch>
                                            </div>
                                        </div>

                                        <!-- <label for="status">Status</label>
                                        <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                            placeholder="Select" optionLabel="label"
                                            (ngModelChange)="onStatusSelect($event)"></p-dropdown> -->
                                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                            <div *ngIf="f.status.errors.required">Please Select Status</div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <!-- <div class="p-col-4">
                        <div class="p-fluid  p-col-12 p-formgrid p-grid">
                            <div class="p-field p-col-12">
                                <label for="link">Link </label>
                                <input formControlName="link" id="link" type="text" pInputText
                                    class="form-control" autocomplete="off">
                            </div>
                        </div> 
                        <div class="p-fluid  p-col-12 p-formgrid p-grid">
                            <div class="p-field p-col-12">
                                <label for="date">Date<span class="mandatory-feilds">*</span></label>
                                <p-calendar formControlName="date" monthNavigator="true" yearNavigator="true" yearRange="{{yearRange}}" dateFormat="dd-mm-yy"
                                   [showIcon]="true" [ngClass]="{ 'is-invalid': submitted && f.date.errors }"></p-calendar>
                                <div *ngIf="((submitted && f.date.errors) || (f.date.errors && (f.date.dirty || f.date.touched)))" class="invalid-feedback">
                                    <div *ngIf="f.date.errors.required">Date is required</div>
                                </div>
                            </div>
                        </div> 
                    </div> -->
                            <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer mt-5">
                                <div class="p-formgrid p-grid">
                                    <p-toast></p-toast>
                                    <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                        class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                    <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                        class="p-button-danger cancel-btn" style="width: auto"></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <p-dialog [(visible)]="cropDialog" [closable]="true" (onHide)="onDialogHide()" [modal]="true" [appendTo]="'body'" [style]="{width: '720px'}" styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">Crop & Adjust Sponsor Image</h5>
                    <p class="crop-dialog-subtitle">Position and scale image to fit mandatory 1583 × 633 aspect ratio</p>
                </div>
            </div>
        </ng-template>

        <div class="crop-dialog-content-wrapper">
            <!-- Toolbar -->
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn" (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn" (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn" (click)="resetZoom()"></button>
                </div>
            </div>

            <!-- Cropper Canvas Box -->
            <div class="cropper-frame mb-3">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1583 / 633"
                    [transform]="transform" [imageQuality]="100" format="png" (imageCropped)="imageCropped($event)">
                </image-cropper>
            </div>

            <!-- Error Notification -->
            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>

            <!-- Preview Card -->
            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">1583 × 633 px</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Preview" class="preview-img" />
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times" class="cancel-action-btn" (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check" class="use-image-btn" (click)="applyCrop()"
                    [disabled]="!!croppedImageError || !croppedImage"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>